var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBinoculars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:5.78px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.93,105.06a36.2,36.2,0,1,1-62.12,37.11m1-68c3.09-6.92,10.52-12.37,20.43-11.76,5.25.34,10.06,2.06,13.6,5.42l27.85,38.51M127,124.54a24.44,24.44,0,1,0,24.44-24.43A24.44,24.44,0,0,0,127,124.54ZM27.5,105.06a36.19,36.19,0,1,0,62.11,37.11M121.54,71l-1.36-9.28s4.74-11.43,18.07-6.81l6.19,7.42M88.63,71,90,61.75s-4.74-11.43-18.07-6.81l-6.19,7.42M89.86,74.12c-3.08-6.92-10.52-11.76-21-11.76a19.69,19.69,0,0,0-13.6,5.42L26.76,105.67M90.48,76a18.52,18.52,0,0,1,15.29-8A19.31,19.31,0,0,1,120,74.74m0,67.43a18.51,18.51,0,0,1-15.29,8.05,19.3,19.3,0,0,1-14.23-6.8m21-11.76a6.81,6.81,0,1,1-6.8-6.81A6.8,6.8,0,0,1,111.51,131.66Zm-29.07-7.12A24.44,24.44,0,1,1,58,100.11,24.44,24.44,0,0,1,82.44,124.54Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinoculars);
export default __webpack_public_path__ + "static/media/BINOCULARS.a689a385cc1ac50fd53647075fceacd2.svg";
export { ForwardRef as ReactComponent };